import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { DateTimePicker } from 'react-widgets';
import { Text, Label, Selector } from '@leverege/ui-elements'

import { ScriptActions, Constants } from '~/actions'
import { List, Screen, TextInput, LabelGroup, Loading, Flex } from '~/views'
import ScriptLogItem from './ScriptLogItem'
import style from './style.css'

const LogLevelFilters = [
  { value : null, name : 'All' },
  { value : 'debug', name : 'Debug' },
  { value : 'info', name : 'Info' },
  { value : 'warning', name : 'Warn' },
  { value : 'error', name : 'Error' },
  { value : 'critical', name : 'Fatal' }
]

const PER_PAGE_VALUES = [
  { name : '1', value : 1 },
  { name : '5', value : 5 },
  { name : '10', value : 10 },
  { name : '50', value : 50 },
  { name : '100', value : 100 }
]

const noItemsView = (
  <Flex className={style.list} align="center" justify="center">
    <div>
      No logs match this filter
    </div>
  </Flex>
)

class ScriptLogsScreen extends React.Component {

  static propTypes = {
    scriptLogs : PropTypes.object.isRequired
  };

  constructor( props ) {
    super( props )
    this.state = {
      loadingMore : false,
      search : props.scriptLogs && props.scriptLogs.search
    }
  }

  componentDidMount() {
    this.performSearch( {} )
  }

  componentWillReceiveProps( nextProps ) {
    const { scriptLogs } = nextProps
    if ( scriptLogs.status !== Constants.STATUS_LOADING && scriptLogs.search !== this.state.search ) {
      this.setState( { search : scriptLogs.search } )
    }
  }

  onEvent = ( item, event ) => {
    if ( item.type === 'loadMore' && event === 'select' ) {
      this.performSearch()
    }
  }

  performSearch( override ) {
    const options = {
      ...this.props.scriptLogs,
      ...override,
      items : undefined,
      status : undefined,
      statusMessage : undefined
    }
    if ( override ) {
      delete options.next
    } else {
      this.setState( {
        loadingMore : true
      } )
    }
    this.props.dispatch( ScriptActions.logs(
      null,
      this.props.match.params.scriptId,
      options
    ) ).then( () => {
      if ( override == null ) {
        this.setState( {
          loadingMore : false
        } )
      }
    } )
  }

  onSearchChange = ( search ) => {
    this.setState( { search } )
    this.performSearch( { search } )
  }

  render() {
    const { scriptLogs } = this.props
    const { params } = this.props.match

    const { loadingMore, search } = this.state

    const scriptId = params && params.scriptId

    const loading = scriptLogs.status == Constants.STATUS_LOADING
    
    let items = scriptLogs.scriptId == scriptId ? scriptLogs.items : []
    
    if ( scriptLogs.next ) {
      items = [ ...items, { type : loadingMore ? 'loadingMore' : 'loadMore' } ]
    }

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Script Logs</Text>
          <LabelGroup>
            <Label>
              <i className="fa fa-search" />
            </Label>
            <TextInput
              className={style.searchInput}
              value={search}
              hint="search"
              changeOnBlur
              changeOnReturn
              onChange={this.onSearchChange} />
          </LabelGroup>
        </Screen.Header>
        <Screen.Content>
          <Flex direction="column" className={style.content}>
            <div className={style.filter}>
              <div className={classnames( style.row, style.left )}>
                <LabelGroup>
                  <Label>
                    Logs Per Page
                  </Label>
                  <Selector
                    className={style.perPageDropdown}
                    values={PER_PAGE_VALUES}
                    value={scriptLogs.perPage}
                    onChange={( { value } ) => { this.performSearch( { perPage : value } ) }} />
                </LabelGroup>
                <LabelGroup>
                  <Label>
                    Severity
                  </Label>
                  <Selector
                    className={style.perPageDropdown}
                    values={LogLevelFilters}
                    value={scriptLogs.severity}
                    onChange={( value ) => { this.performSearch( { severity : value.value } ) }} />
                </LabelGroup>
              </div>
              <div className={classnames( style.row, style.right )}>
                <LabelGroup>
                  <Label>Start</Label>
                  <DateTimePicker
                    onChange={( v ) => { this.performSearch( { start : new Date( v ).toISOString() } ) }}
                    format="YYYY-MM-DDTHH:mm"
                    value={scriptLogs.start ? new Date( scriptLogs.start ) : null} />
                </LabelGroup>
                <LabelGroup>
                  <Label>End</Label>
                  <DateTimePicker
                    onChange={( v ) => { this.performSearch( { end : new Date( v ).toISOString() } ) }}
                    format="YYYY-MM-DDTHH:mm"
                    value={scriptLogs.start ? new Date( scriptLogs.end ) : null} />
                </LabelGroup>
              </div>
            </div>
            {
              loading && !loadingMore ?
                <Loading className={style.list} show /> :
                (
                  <List
                    className={classnames( style.list )}
                    onEvent={this.onEvent} 
                    noItemsView={loading ? <Loading className={style.list} show /> : noItemsView}
                    items={items}
                    itemView={ScriptLogItem}
                    itemProps={{ hideNavButtons : false }} />
                )
            }
            
          </Flex>
        </Screen.Content>
      </Screen>
    )
  }
}

export default connect(
  state => ( {
    projects : state.projects,
    scriptLogs : state.scriptLogs
  } )
)( ScriptLogsScreen )
